/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/media_library_asset_data/:asset_id" endpoint
 */
import fetch from "@lib/fetch";

import { createGetFetcherFunctionWithShadowError, reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdMediaLibraryAssetDataAssetId } from "./constants";
import type { MediaLibraryAssetDataErrors } from "./types";
import { type MediaLibraryAssetDataResult } from "./types";
import { isMediaLibraryAssetDataResult } from "./validators";

export const getMediaLibraryAssetData = reactQueryFetcherAdapter(
  engagementAppGroupIdMediaLibraryAssetDataAssetId,
  createGetFetcherFunctionWithShadowError<MediaLibraryAssetDataErrors>()(
    (signal: AbortSignal, appGroupId: string, assetId: string): Promise<MediaLibraryAssetDataResult> => {
      return fetch(
        `/engagement/${appGroupId}/media_library_asset_data/${assetId}`,
        "GET",
        {},
        { signal },
        { propagateFetchRequestError: false }
      );
    }
  ),
  isMediaLibraryAssetDataResult
);
